
import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect }  from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import { languageManager } from '../utils/languageManager'
import { closeConfig } from '../App/actions'

import {platformHandler} from '../platforms/PlatformHandler'

import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';


import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import Button from '@material-ui/core/Button';

import { COLOR } from '../App/constants';

import { closeModalWindow } from '../App/actions'

const styles = theme => ({  
    modalWn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: "100000001",         
    },        

    divLoader: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      outline: "0px solid transparent",
    }, 

    divText: {
      marginTop: "8px",
      color: "white",
      fontFamily: "Roboto",
      maxWidth: "200px",
      textAlign: "center",
    },

    circular: {
      outline: "0px solid transparent",
      color: "white",
    }
});

class FwModalLoader extends React.Component {

  componentDidMount() {     
  }
  
  render() {
    const { classes } = this.props;
    
    //let showTitle = modalWindow.title != '' && modalWindow.title != undefined;

    return (
      <React.Fragment>        
        <Modal
          open={true}          
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ root: classes.modalWn }}    
          disableAutoFocus={true}      
        >
          <div className={classes.divLoader}>     
            <CircularProgress size={50} className={classes.circular} />
            {this.props.text && <div className={classes.divText}>{this.props.text}</div>}
          </div> 
        </Modal>
      </React.Fragment>      
    );
  }
}  

export default (withStyles(styles,{ withTheme: true })(FwModalLoader));



// WEBPACK FOOTER //
// ./src/containers/components/FwModalLoader.js